// extracted by mini-css-extract-plugin
export default {"wrapper":"BestSellerItem_wrapper__0+D21","imgWrapper":"BestSellerItem_imgWrapper__Bh1QI","img":"BestSellerItem_img__j1rUc","name":"BestSellerItem_name__gJaY+"};